import { ESM2to1StockItem, ESM2to1StocksFilterOptions } from '@/types/esm2to1Stocks';
import { apiClient } from './client';

export const getESM2to1StocksFilterOptions = (): ESM2to1StocksFilterOptions => {
  return {
    stock_name: '',
    watchlists: []
  };
};

/**
 * Fetch ESM 2-to-1 stocks based on filter criteria
 */
export const getESM2to1Stocks = async (filters: Record<string, unknown> = {}): Promise<ESM2to1StockItem[]> => {
  try {
    const response = await apiClient.get('/market/esm-2-to-1-stocks', {
      params: filters
    });
    
    // Type assertion for response structure
    const responseData = response.data as { data: ESM2to1StockItem[] };
    
    // Ensure we have a valid response structure
    if (!responseData.data) {
      console.warn('Unexpected API response structure:', responseData);
      return [];
    }
    
    return responseData.data || [];
  } catch (error) {
    console.error('Error fetching ESM 2-to-1 stocks:', error);
    throw error;
  }
};
